import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {injectIntl} from "react-intl";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import {setLookOpened} from "../../../../actions/lookFunctions";
import {ROUTES} from "../../../../routes";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";

const LookMainHeaderCloseButton = (props) => {

  const {intl, history, setLookOpened} = props;

  const closeButtonClick = () => {
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookMenuHeaderClose);
    setLookOpened(false);
    history.push(ROUTES.home);
  };

  return (
    <IconButton aria-label={intl.formatMessage({id:"iconButton.close"})}
                className="look-icon look-icon--small look-icon--white"
                onClick={closeButtonClick}>
      <CloseIcon/>
    </IconButton>
  )
};

const mapStateToProps = () => {
  return {
  };
};

const mapDispatchToProps = {
  setLookOpened,
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(LookMainHeaderCloseButton)
  )
)
